<template>
  <div>
    <div class="loader" >
      <div class="line" v-for="item in 9" :key="item"></div>
    </div>
  </div>
</template>

<script>
export default {
name: "iline",
}
</script>

<style scoped lang='less'>
.loader {
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transform:rotate(90deg);
}

.loader .line {
  width: 90px;
  height: 5px;
  opacity: 0.2;
  border-radius: 5px;
  margin-bottom: 46.5px;
  background-color: #3563A6;
  -webkit-animation: expand 2.6s ease-in-out infinite;
  -moz-animation: expand 2.6s ease-in-out infinite;
  -o-animation: expand 2.6s ease-in-out infinite;
  animation: expand 2.6s ease-in-out infinite;
}
.loader .line:nth-child(2) {
  -webkit-animation-delay: 180ms;
  -moz-animation-delay: 180ms;
  -o-animation-delay: 180ms;
  animation-delay: 180ms;
}
.loader .line:nth-child(3) {
  -webkit-animation-delay: 360ms;
  -moz-animation-delay: 360ms;
  -o-animation-delay: 360ms;
  animation-delay: 360ms;
}
.loader .line:nth-child(4) {
  -webkit-animation-delay: 540ms;
  -moz-animation-delay: 540ms;
  -o-animation-delay: 540ms;
  animation-delay: 540ms;
}
.loader .line:nth-child(5) {
  -webkit-animation-delay: 720ms;
  -moz-animation-delay: 720ms;
  -o-animation-delay: 720ms;
  animation-delay: 720ms;
}
.loader .line:nth-child(6) {
  -webkit-animation-delay: 900ms;
  -moz-animation-delay: 900ms;
  -o-animation-delay: 900ms;
  animation-delay: 900ms;
}
.loader .line:nth-child(7) {
  -webkit-animation-delay: 1080ms;
  -moz-animation-delay: 1080ms;
  -o-animation-delay: 1080ms;
  animation-delay: 1080ms;
}
.loader .line:nth-child(8) {
  -webkit-animation-delay: 1260ms;
  -moz-animation-delay: 1260ms;
  -o-animation-delay: 1260ms;
  animation-delay: 1260ms;
}
.loader .line:nth-child(9) {
  -webkit-animation-delay: 1440ms;
  -moz-animation-delay: 1440ms;
  -o-animation-delay: 1440ms;
  animation-delay: 1440ms;
}
.loader .line:last-child {
    margin-bottom: 0px;
}
/*  KEYFRAMES
========================================== */

@-webkit-keyframes expand {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  25% {
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
  }
}
@-moz-keyframes expand {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  25% {
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
  }
}
@-o-keyframes expand {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  25% {
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
  }
}
@keyframes expand {
  0% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
    // opacity: 0.6;
  }
  25% {
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
    opacity: 0.6;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/line.vue